import OriginSelect from './Select';

type SelectProps = typeof OriginSelect & {};
const Select = OriginSelect as SelectProps;

export { Select };
